import Modal, { Styles } from 'react-modal'
import { copyJson } from '../../helpers/general.helper';

Modal.setAppElement('#root');

const modalStyles = {
	overlay: {
		zIndex: 9999,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		zIndex: 10000,
		position: 'fixed' as const,
	},
};

interface CustomModalProps {
	showModal: boolean;
	setShowModal: (show: boolean) => void;
	children: React.ReactNode;
	titulo?: string;
	width?: string;
	height?: string;
}

const CustomModal = ({showModal, setShowModal, titulo, children, width='60%', height='60%'}: CustomModalProps) => {

	const customStyles = copyJson(modalStyles);
	customStyles.content.width = width;
	customStyles.content.height = height;
	customStyles.content.maxHeight = '90vh';

	return (
		<Modal 
			isOpen={showModal}
			onRequestClose={() => setShowModal(false)}
			style={customStyles}
			contentLabel={titulo || ''}
		>
			{children}
		</Modal>
	)
}

export default CustomModal